// Auto-generated normalizer for table: Usuario_Rol
export function usuarioRolNormalize(row) {
  return {
    idUsuarioRol: row.idUsuarioRol ?? row.IdUsuarioRol ?? row['IdUsuarioRol'] ?? 0,
    idUsuario: row.idUsuario ?? row.IdUsuario ?? row['IdUsuario'] ?? 0,
    idRol: row.idRol ?? row.IdRol ?? row['IdRol'] ?? 0,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
